import * as React from "react";
import { classes, style, stylesheet } from "typestyle";
import {
  Gray100,
  typeCompact14Medium,
  typeCompact12Medium,
} from "@traceair/tds";

const css = stylesheet({
  container: {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    boxSizing: "border-box",
    paddingLeft: "4px",
    cursor: "pointer",
    paddingTop: 8,
    paddingBottom: 8,
    minHeight: 48,
  },
  containerCentered: {
    alignItems: "center",
  },
  icon: {
    display: "flex",
    height: "24px",
    width: "40px",
    alignItems: "center",
    justifyContent: "center",
  },
  textContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingRight: "10px",
    overflow: "hidden",
    $nest: {
      "&:not(:last-child)": {
        bottom: 2,
      },
    },
  },
  title: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    marginBottom: 2,
  },
  subtitle: {
    color: Gray100,
    overflowWrap: "anywhere",
  },
});

interface IProps {
  leftIcon: React.ReactNode;
  leftLabel: string | React.ReactNode;
  description: string;
  borderBottomColor?: string;
  backgroundColor: string;
  onClick: () => void;
}

export function ExistingGcpItem({
  borderBottomColor,
  backgroundColor,
  leftIcon,
  leftLabel,
  description,
  onClick,
}: IProps) {
  const colorClass = style({
    backgroundColor: backgroundColor || "#fff",
    borderBottom: borderBottomColor ? `1px solid ${borderBottomColor}` : "none",
  });

  return (
    <div
      className={classes(
        css.container,
        !description && css.containerCentered,
        colorClass,
      )}
      onClick={onClick}
    >
      <div className={css.icon}>{leftIcon}</div>
      <div className={css.textContainer}>
        <span
          title={typeof leftLabel === "string" ? leftLabel : ""}
          className={classes(css.title, typeCompact14Medium)}
        >
          {leftLabel}
        </span>
        <span className={classes(css.subtitle, typeCompact12Medium)}>
          {description}
        </span>
      </div>
    </div>
  );
}
